import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../contexts/user.context";
import Image from "../Image/Image.component";
import errorImg from "../../assets/images/error.png";

const ErrorPage = ({ error }: { error?: any }) => {
  const { t } = useTranslation();
  const { signOut } = useContext(UserContext);
  const [dev, setDev] = useState<boolean>(false);

  useEffect(() => {
    document.title = "Something went wrong";
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.ctrlKey &&
        event.altKey &&
        event.shiftKey &&
        (event.key === "D" || event.key === "d")
      ) {
        setDev((prevDev) => !prevDev);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="bg-white w-full h-full flex flex-col items-center justify-center gap-4 py-8">
      {!dev && (
        <div className="flex flex-col items-center gap-4">
          <h1 className="text-4xl font-bold text-gray-800">
            Oops! Something went wrong.
          </h1>
          <p className="text-lg text-gray-600">Please try again later.</p>
          <Image
            src={errorImg}
            addBaseLink={false}
            alt="Error"
            className="w-[30%] object-contain -my-[3%]"
          />
          {import.meta.env.VITE_PROD !== "true" && (
            <p className="text-xl text-red-600">
              Press Ctrl + Alt + Shift + D to see error details.
            </p>
          )}
        </div>
      )}
      {dev && (
        <div className="flex flex-col items-center gap-4 my-5">
          <h1 className="text-4xl font-bold text-gray-800">
            {error?.name || "Error"}
          </h1>
          <p className="text-2xl text-gray-600">{error?.message}</p>
          <pre className="text-xl text-gray-500">{error?.stack}</pre>
        </div>
      )}
      <div className="flex items-center gap-4">
        <button
          className="main_btn"
          onClick={() => {
            window.location.reload();
          }}
        >
          {t("refresh")}
        </button>
        <button
          className="cancel_btn"
          onClick={() => {
            signOut();
            window.location.reload();
          }}
        >
          {t("signout")}
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
